<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Contraproposta</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Enviar Contraproposta',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnGoBack" type="button" color="primary" elevation="0" outlined
                                    to="/revisao-credito">Voltar</v-btn>
                            </template>
                            <span>Voltar</span>
                        </v-tooltip>
                    </div>
                </div>

            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-title">Contraproposta - Importar e Processar Arquivo CSV</v-card-title>

                    <v-card-text>
                        <v-alert
                        dense
                        type="info"
                      >
                            <template v-slot:prepend>
                                <v-icon color="#FFFFFF">mdi-information</v-icon>
                            </template>
                            <strong>Formato esperado do arquivo CSV:</strong>
                            <ul class="mt-2">
                                <li>Separado por ponto e vírgula (;)</li>
                                <li>Cabeçalho: <strong>id</strong> | <strong>cpf_cnpj</strong> | <strong>valor</strong> |
                                    <strong>motivo</strong> | <strong>documentos</strong> (link dos documentos separados por ",")</li>
                                <li>Máximo de {{ maxRecords }} registros por arquivo</li>
                                <li>Codificação: UTF-8</li>
                            </ul>
                        </v-alert>

                        <v-file-input v-model="file" label="Selecionar arquivo CSV" accept=".csv" :rules="fileRules"
                            @change="handleFileUpload" show-size truncate-length="50" class="file-input-custom"
                            prepend-icon="mdi-file-document-outline" :loading="loading" :chips="true"
                            counter></v-file-input>

                        <v-card v-if="processingSummary.total > 0" outlined class="mt-4 pa-4">
                            <h3 class="subtitle-1 mb-2">Resumo da importação do arquivo</h3>
                            <v-row>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 primary--text">{{ processingSummary.total }}</div>
                                        <div class="text-subtitle-2">Total de registros</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 success--text">{{ processingSummary.valid }}</div>
                                        <div class="text-subtitle-2">Registros válidos</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 error--text">{{ processingSummary.invalid }}</div>
                                        <div class="text-subtitle-2">Registros com erro</div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-data-table v-if="errors.length > 0" :headers="errorTableHeaders" :items="errors" class="mt-5"
                            dense>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Registros com erro</v-toolbar-title>
                                </v-toolbar>
                            </template>
                        </v-data-table>

                        <v-alert v-if="errorMessage" type="error" class="mt-4" dense>
                            <span v-html="errorMessage"></span>
                        </v-alert>

                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" color="primary" class="mt-4"
                                    :disabled="!canProcess || errors.length > 0" @click="processData"
                                    :loading="processing">
                                    Processar Dados
                                </v-btn>
                            </template>
                            <span>Enviar dados para processamento</span>
                        </v-tooltip>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modal de resultado -->
        <v-dialog v-model="dialog" persistent max-width="800">
            <v-card>
                <v-card-title>
                    <span v-if="errorsBack.length > 0" class="text-h6">Erros no processamento</span>
                    <span v-else class="text-h6">Processamento Concluído</span>
                </v-card-title>
                <v-card-text>
                    <div>
                        <p>{{ summaryMessage }}</p>
                    </div>
                    <div v-if="errorsBack.length > 0">
                        <p>Os seguintes erros foram encontrados:</p>
                        <v-data-table :headers="errorBackTableHeaders" :items="errorsBack" dense class="mt-3">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.cpf_cnpj }}</td>
                                    <td class="text-left">{{ item.valor }}</td>
                                    <td class="text-left">{{ item.motivo }}</td>
                                    <td class="text-left">{{ item.documentos }}</td>
                                    <td class="text-left">{{ item.error }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>


<script>
import Vue from "vue";
import VueLodash from 'vue-lodash';
import _ from 'lodash';
import axios from 'axios';
import { cpf, cnpj } from 'cpf-cnpj-validator';

Vue.use(VueLodash);

export default {
    name: "ObjectionEventProposal",

    data() {
        return {
            errorsBack: [],
            dialog: false,
            file: null,
            summaryMessage: "",
            processedData: [],
            csvData: [],
            loading: false,
            processing: false,
            errors: [],
            errorMessage: "",
            maxRecords: 500,
            maxFileSize: 5 * 1024 * 1024, // 5MB
            processingSummary: {
                total: 0,
                valid: 0,
                invalid: 0
            },
            dataset: {
                loading: null,
            },
            errorTableHeaders: [
                { text: "Linha", value: "line", width: "80px" },
                { text: "Erro(s)", value: "errors" },
            ],
            errorBackTableHeaders: [
                { text: 'ID', value: 'id' },
                { text: 'CPF/CNPJ', value: 'cpf_cnpj' },
                //{ text: 'Status', value: 'status' },
                { text: 'Valor', value: 'valor' },
                { text: 'Motivo', value: 'motivo' },
                { text: 'Documentos', value: 'documentos' },
                { text: 'Erro', value: 'error' }
            ],
            breadcrumbItems: [
                {
                    text: 'Homepage',
                    disabled: false,
                    to: '/home',
                    exact: true,
                },
                {
                    text: 'Enviar Contraproposta',
                    disabled: true,
                    exact: true,
                },
            ],
            fileRules: [
                v => !!v || 'Arquivo é obrigatório.',
                v => !v || v.size <= this.maxFileSize || 'Arquivo muito grande! Máximo 5MB.',
                v => !v || v.type === 'text/csv' || 'Formato inválido! Apenas CSV é aceito.'
            ],
            expectedHeaders: ['id', 'cpf_cnpj', 'valor', 'motivo', 'documentos']
        };
    },

    computed: {
        canProcess() {
            return this.file &&
                !this.loading &&
                !this.processing &&
                this.errorMessage.length === 0 &&
                this.processingSummary.valid > 0;
        }
    },

    methods: {
        async handleFileUpload() {
            if (!this.file) {
                this.errorMessage = "Nenhum arquivo foi selecionado.";
                return;
            }

            this.loading = true;
            this.errors = [];
            this.errorMessage = "";
            this.processingSummary = { total: 0, valid: 0, invalid: 0 };

            try {
                const content = await this.readFileContent(this.file);
                const parsedData = this.parseCSV(content);

                if (!parsedData.success) {
                    this.errorMessage = parsedData.message;
                    this.errors = parsedData.errors;
                    return;
                }

                this.updateProcessingSummary(parsedData);

                this.errors = parsedData.errors;

            } catch (error) {
                this.errorMessage = "Erro ao processar arquivo: " + error.message;
            } finally {
                this.loading = false;
            }
        },

        readFileContent(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const content = e.target.result;
                        resolve(content);
                    } catch (error) {
                        reject(new Error('Erro ao ler conteúdo do arquivo'));
                    }
                };

                reader.onerror = () => {
                    reject(new Error('Erro ao ler arquivo'));
                };

                reader.readAsText(file, 'UTF-8');
            });
        },

        parseCSV(data) {
            const lines = data.split("\n").filter(line => line.trim());
            const firstLine = lines[0];
            const separator = firstLine.includes(';') ? ';' : ',';
            const headers = lines[0].split(separator)
                .map(h => h.trim().toLowerCase())
                .filter(h => h);

            if (!this.validateHeaders(headers)) {
                return {
                    success: false,
                    message: `Cabeçalho do arquivo inválido! <br> - Encontrado: ${headers.join(separator)} <br> - Esperado: ${this.expectedHeaders.join(separator)}`,
                    errors: [{
                        line: 1,
                        errors: `Cabeçalho esperado: ${this.expectedHeaders.join(separator)}`
                    }]
                };
            }

            if (lines.length - 1 > this.maxRecords) {
                return {
                    success: false,
                    message: `O arquivo excede o limite de ${this.maxRecords} registros permitidos.`,
                    errors: []
                };
            }

            const result = [];
            const errors = [];
            const validRecords = [];

            for (let i = 1; i < lines.length; i++) {
                let row = this.splitCSVRow(lines[i], separator);

                if (row.length !== headers.length) {
                    errors.push({
                        line: i + 1,
                        errors: `Número incorreto de colunas! Esperado: ${headers.length}, Encontrado: ${row.length}`
                    });
                    continue;
                }

                const record = this.createRecord(row, i + 1);

                const documentosIndex = headers.indexOf("documentos");
                
                if (documentosIndex !== -1 && record.documentos) {
                    record.documentos = record.documentos
                        .split(',')
                        .map(doc => doc.trim())
                        .filter(doc => doc);
                }

                const validation = this.validateRecord(record);

                if (validation.isValid) {
                    result.push(record);
                    validRecords.push({
                        id: record.id,
                        cpf_cnpj: record.cpf_cnpj,
                        amount: record.valor,
                       // status: record.status,
                        reason: record.motivo,
                        documents: record.documentos,
                    });
                } else {
                    errors.push({
                        line: i + 1,
                        errors: validation.errors.join(", ")
                    });
                }
            }

            this.processedData = validRecords;

            return {
                success: true,
                validData: result,
                errors,
                count: {
                    total: lines.length - 1,
                    valid: validRecords.length,
                    invalid: errors.length
                }
            };
        },

        splitCSVRow(row, separator) {

            const regex = new RegExp(
                `(?:${separator}|\\r?\\n|^)(?:"([^"]*(?:""[^"]*)*)"|([^"${separator}\\r\\n]*))`,
                "g"
            );

            const result = [];
            let match;

            while ((match = regex.exec(row))) {
                if (match[1] !== undefined) {
                    result.push(match[1].replace(/""/g, '"'));
                } else {
                    result.push(match[2]);
                }
            }

            const expectedColumnCount = 4;
            while (result.length < expectedColumnCount) {
                result.unshift(null);
            }

            return result.map(cell => (cell ? cell.trim() : null));
        },

        validateHeaders(headers) {
            const expectedHeadersLower = this.expectedHeaders.map(h => h.toLowerCase());
            const headersLower = headers.map(h => h.toLowerCase());

            return expectedHeadersLower.every(expected =>
                headersLower.includes(expected)
            );
        },

        validateRecord(record) {
            const errors = [];

            if (!record.id || !/^\d+$/.test(record.id.toString())) {
                errors.push("O campo 'ID' está vazio, ausente ou inválido.");
            }

            if (!this.validateCpfCnpj(record.cpf_cnpj)) {
                errors.push("CPF/CNPJ inválido ou mal formatado");
            }

            // if (record.status !== 1 && record.status !== 2 && record.status !== 3 && record.status !== 4) {
            //     errors.push( "Status deve ser 'Aprovado', 'Não Aprovado', 'Aprovado parcialmente' ou 'Validado'");
            // }
            
            if (!record.valor || isNaN(record.valor)) {
                errors.push("Valor deve ser preenchido e ser um número válido");
            }

            if (!record.motivo || record.motivo.trim().length < 3) {
                errors.push("Motivo deve ter no mínimo 3 caracteres");
            }

            if (
                !record.documentos ||
                !Array.isArray(record.documentos) ||
                record.documentos.length === 0
            ) {
                errors.push("O campo 'documentos' está vazio ou ausente.");
            }

            return {
                isValid: errors.length === 0,
                errors
            };
        },

        createRecord(row, lineNumber) {

            return {
                id: row[0] ? row[0].trim() : null,
                cpf_cnpj: row[1] ? this.normalizeValue(row[1]) : null,
                valor: row[2] ? this.normalizeCurrency(row[2]) : null,
                motivo: row[3] ? row[3].trim() : null,
                documentos: row[4] ? row[4].trim() : null,
                line: lineNumber
            };
        },

        validateCpfCnpj(value) {
            const normalizedValue = this.normalizeValue(value);

            return normalizedValue.length === 11 ?
                cpf.isValid(normalizedValue) :
                cnpj.isValid(normalizedValue);
        },

        normalizeCurrency(value) {
            if (!value || typeof value !== 'string') {
                return null;
            }

            let normalized = value.replace(/[^\d,.-]/g, "").trim();

            normalized = normalized.replace(",", ".");

            if ((normalized.match(/\./g) || []).length > 1) {
                normalized = normalized.replace(/\.(?=\d{3})/g, "");
            }

            const result = parseFloat(normalized);

            return isNaN(result) ? null : parseFloat(result.toFixed(2));
        },

        // convertStatus(status) {
            
        //     if (!status || typeof status !== 'string' || status.trim() === "") {
        //         return 0; 
        //     }

        //     const statusLower = status.trim().toLowerCase();

        //     if (statusLower === "aprovado") {
        //         return 1; 
        //     }

        //     if (statusLower === "não aprovado" || statusLower === "nao aprovado") {
        //         return 2; 
        //     }

        //     if (statusLower === "aprovado parcialmente") {
        //         return 3;
        //     }

        //     if (statusLower === "validado") {
        //         return 4;
        //     }

        //     return 5; 
        // },

        normalizeValue(value) {
           // return value.replace(/[^\d]/g, "");
           return (value || '').toString().replace(/[^\d]/g, "");
        },

        updateProcessingSummary(parsedData) {
            this.processingSummary = {
                total: parsedData.count.total,
                valid: parsedData.count.valid,
                invalid: parsedData.count.invalid
            };
        },

        async processData() {
            if (!this.canProcess) return;

            this.processing = true;

            try {

                if (this.processedData.length === 0) {
                    this.$dialog.notify.error("Dados processados com sucesso!", {
                        position: "top-right",
                        timeout: 3000
                    });
                }

                const payload = {
                    records: this.processedData,
                    totalRecords: this.processedData.length
                };

                const response = await axios.post('/api/admin/user-objection-events/client-mass-proposal', payload);

                const data = response.data;

                if (data.status && data.content) {

                    this.summaryMessage = data.content.message;

                    if (data.content.errors && data.content.errors.length > 0) {

                        this.errorsBack = data.content.errors.map((errorItem) => ({
                            id: errorItem.record.id,
                            cpf_cnpj: errorItem.record.cpf_cnpj,
                            //status: errorItem.record.status,
                            valor: errorItem.record.amount,
                            motivo: errorItem.record.reason,
                            documentos: errorItem.record.documents,
                            error: errorItem.error
                        }));

                    } else {
                        this.errorsBack = [];
                    }

                } else {
                    throw new Error("Erro ao enviar dados para o servidor!");
                }

                this.clearForm();

            } catch (error) {
                this.$dialog.notify.error("Erro ao processar dados: " + error.message, {
                    position: "top-right",
                    timeout: 5000
                });
            } finally {
                this.dialog = true;
                this.processing = false;
            }
        },

        clearForm() {
            this.file = null;
            this.processedData = [];
            this.errors = [];
            this.errorMessage = "";
            this.processingSummary = { total: 0, valid: 0, invalid: 0 };
        },
    }
};
</script>

<style>
.card-form-outlined {
    padding: 20px;
}

.card-title {
    padding-bottom: 8px !important;
    display: flex !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
}

.drop-area {
    border: 2px dashed #757575;
    padding: 20px;
    text-align: left;
}

.file-input-custom ::v-deep .v-file-input__text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: none;
}

.file-count {
    margin-top: 10px;
    font-size: 14px;
    text-align: right;
}
</style>